import Swiper, { Navigation } from 'swiper';


const useFilter = () => {
  const filters = $('.filter')

  const detectIsLocked = (swiper) => {
    const { isLocked, $el } = swiper
    if (isLocked) {
      $el.addClass('is-centered')
    }
    else {
      $el.removeClass('is-centered')
    }
  }

  const options = {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 10,
    breakpoints: {
      768: {
        spaceBetween: 20
      }
    },
    on: {
      afterInit(swiper) {
        detectIsLocked(swiper)
      },
      resize(swiper) {
        detectIsLocked(swiper)
      }
    }
  }

  filters.each((i, el) => {
    // init swiper
    const filter = $(el)
    const swiperEl = filter.find('.filter-swiper')
    const prevEl = filter.find('.filter-prev-btn')
    const nextEl = filter.find('.filter-next-btn')

    new Swiper(swiperEl[0], {
      ...options,
      navigation: {
        prevEl: prevEl[0],
        nextEl: nextEl[0],
      }
    })

    // click change active index
    const btns = filter.find('.rect-btn')
    btns.on('click', function() {
      const self = $(this)
      self.addClass('is-active').closest('.swiper-slide').siblings().find('.rect-btn').removeClass('is-active')
    })
  })
}


// icon-filter
const useIconFilter = () => {
  const filters = $('.icon-filter')

  const detectIsLocked = (swiper) => {
    const { isLocked, $el } = swiper
    if (isLocked) {
      $el.addClass('is-centered')
    }
    else {
      $el.removeClass('is-centered')
    }
  }

  const options = {
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 0,
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 0
      },
      996: {
        slidesPerView: 4,
        spaceBetween: 0
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 16
      },
      1480: {
        slidesPerView: 6,
        spaceBetween: 30
      },
    },
    on: {
      afterInit(swiper) {
        detectIsLocked(swiper)
      },
      resize(swiper) {
        detectIsLocked(swiper)
      }
    }
  }

  filters.each((i, el) => {
    // init swiper
    const filter = $(el)
    const swiperEl = filter.find('.filter-swiper')
    const prevEl = filter.find('.filter-prev-btn')
    const nextEl = filter.find('.filter-next-btn')

    new Swiper(swiperEl[0], {
      ...options,
      navigation: {
        prevEl: prevEl[0],
        nextEl: nextEl[0],
      }
    })

    // click change active index
    const btns = filter.find('button')
    btns.on('click', function() {
      const self = $(this)
      self.addClass('is-active').closest('.swiper-slide').siblings().find('button').removeClass('is-active')
    })
  })
}


export {
  useFilter,
  useIconFilter
}